/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "maxLines", "className"];
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseTextElement } from '../common';
var SNIPPET_DEFAULT_MAX_LINES = 3;
var snippetBaseStyle = null;
var SnippetElement = function SnippetElement(props) {
  var _ref = props !== null && props !== void 0 ? props : {},
    overrideContent = _ref.content,
    _ref$maxLines = _ref.maxLines,
    maxLines = _ref$maxLines === void 0 ? SNIPPET_DEFAULT_MAX_LINES : _ref$maxLines,
    className = _ref.className,
    restOfProps = _objectWithoutProperties(_ref, _excluded);
  var context = useFlexibleUiContext();
  return /*#__PURE__*/React.createElement(BaseTextElement, _extends({
    content: overrideContent !== null && overrideContent !== void 0 ? overrideContent : context === null || context === void 0 ? void 0 : context.snippet,
    maxLines: maxLines,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv", className])
  }, restOfProps));
};
export default SnippetElement;